import 'debug';
import { e as entryMixin } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import './Slider.js';
import { _ as __vue_normalize__ } from './normalize-component.js';
import './lipSync.js';
import VideoPlayer from './VideoPlayer.js';

//
var script = {
  mixins: [entryMixin],
  methods: {
    getSubtitles: function getSubtitles() {
      console.log('getSubtitles() ', this.entryData);

      if (this.entryData.Subtitles) {
        return {
          BinaryID: this.entryData.Subtitles.BinaryID,
          Url: this.$xp.settings.baseUrl + 'xpedeo/' + this.entryData.Subtitles.Url,
          srclang: this.entryData.Subtitles.srclang,
          label: this.entryData.Subtitles.label
        };
      }

      return null;
    }
  },
  computed: {
    posterUrl: function posterUrl() {
      if (this.entryData.VideoThumb.BinaryID > 0) {
        return this.$xp.content.getImageUrl(this.entryData.VideoThumb);
      } else {
        return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
      }
    }
  },
  components: {
    'video-player': VideoPlayer
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "js-entry o-entry c-video-entry" },
    [
      _vm.$xp.evaInstalled
        ? _c("video-player", {
            directives: [{ name: "eva-media", rawName: "v-eva-media" }],
            attrs: {
              source:
                _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.entryData.Video.Url,
              binaryId: _vm.entryData.Video.BinaryID,
              pageId: _vm.entryData.Video.BinaryID,
              poster: _vm.posterUrl,
              autoPlay: _vm.entryData.Json.AutoPlay,
              loop: _vm.entryData.Json.Loop,
              muted: _vm.entryData.Json.Muted,
              showControls: _vm.entryData.Json.ShowControls,
              subtitles: _vm.getSubtitles(),
              lipSyncUrl:
                _vm.pageData.Class === "XpVideoSync"
                  ? _vm.pageData.lipSyncUrl
                  : null
            }
          })
        : _c("video-player", {
            attrs: {
              source:
                _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.entryData.Video.Url,
              binaryId: _vm.entryData.Video.BinaryID,
              pageId: _vm.entryData.Video.BinaryID,
              poster: _vm.posterUrl,
              autoPlay: _vm.entryData.Json.AutoPlay,
              loop: _vm.entryData.Json.Loop,
              muted: _vm.entryData.Json.Muted,
              showControls: _vm.entryData.Json.ShowControls,
              subtitles: _vm.getSubtitles(),
              lipSyncUrl:
                _vm.pageData.Class === "XpVideoSync"
                  ? _vm.pageData.lipSyncUrl
                  : null
            }
          })
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
